import PropTypes from 'prop-types';

export default {
  currencyCode: PropTypes.string.isRequired,
  formatted: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
};
